module.exports = {
  PAYMENTS_NFE: 'payments_nfe',
  TRANSFERS_VERIFICATION_PAYEE_WORKAROUND: 'transfers_verification_payee_workaround',
  WEALTH_CRYPTO: 'wealth_crypto',
  WEALTH_CRYPTO_SHOW_GLOBAL_POSITION: 'wealth_crypto_show_global_position',
  WEALTH_CRYPTO_PG_BANNER: 'wealth_crypto_pg_banner',
  WEALTH_CRYPTO_TEST_LANDING: 'wealth_crypto_test_landing',
  COMMERCIAL_CRYPTO_ASSETS_COMPONENT: 'pg_commercial_crypto_asset_component',
};
